import { cloneDeep } from 'lodash-es';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { AUTH_ACTIONS } from 'src/containers/auth-container/actions/AuthActions';
import { CompanyDefaultProps } from 'src/containers/company-container/CompanyPropTypes';
import { COMPANY_ACTIONS } from '../actions/CompanyActions';

const initialState = () => ({
    currentRecord: { ...cloneDeep(CompanyDefaultProps) },

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        // SEARCH
        case COMPANY_ACTIONS.COMPANY_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case COMPANY_ACTIONS.COMPANY_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case COMPANY_ACTIONS.COMPANY_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // UPSERT
        case COMPANY_ACTIONS.COMPANY_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case COMPANY_ACTIONS.COMPANY_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case COMPANY_ACTIONS.COMPANY_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // RESET
        case COMPANY_ACTIONS.COMPANY_RESET: {
            return {
                ...state,
                currentRecord: { ...CompanyDefaultProps },
            };
        }

        // LOGOUT
        case AUTH_ACTIONS.LOGOUT:
            return {
                ...initialState(),
            };
        default:
            return state;
    }
};
